import client from './client';

// 그리드(표) 개인화 설정 — 열 순서/숨김/너비, 정렬, 밀도, 페이지 크기. 필터는 다루지 않는다.
// ksm_backend/ksm_frontend 포팅(2026-10-20, bito 4단계 UI 현대화).
const BASE_URL = '/api/v1/common/grid-pref';

/** 로그인 사용자 본인의 설정 전체. { list: [{ gridKey, prefJson, updDt }] } */
export const fetchGridPrefs = () => client.get(BASE_URL);

export const saveGridPref = (gridKey, prefJson) => client.put(BASE_URL, { gridKey, prefJson });

export const deleteGridPref = (gridKey) => client.delete(BASE_URL, { params: { gridKey } });
